export const CollapseIcon: React.FC = props => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.20485 9.61497L6.05101 9.61497C6.60329 9.61497 7.05101 10.0627 7.05101 10.615L7.05101 13.4611"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.41003 10.2555L1.92285 14.7427"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.61448 3.20534L9.61448 6.0515C9.61448 6.60378 10.0622 7.0515 10.6145 7.0515L13.4606 7.0515"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.255 6.40954L14.7422 1.92236"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
